<template>
  <div class="container mb-4">
    <div class="wrapper">
      <profile-image
        :size="size"
        :user-status="userStatus"
        :hide-user-status="hideUserStatus"
      />
      <input
        type="file"
        accept="image/*"
        class="input"
        :disabled="uploading"
        :aria-label="$t('editProfileScreen.changeProfileImage')"
        @change="changeImage($event)"
      />
      <v-progress-circular
        v-if="uploading"
        color="white"
        indeterminate
        class="icon"
      />
      <div v-if="!uploading" class="icon">
        <icon
          default-icon-name="mdiCamera"
          :size="32"
          color="white"
          role="img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mdiCamera} from '@mdi/js'
import {mapActions} from 'vuex'
import ProfileImage from '@/components/profile/ProfileImage'
import Icon from '@/components/ui/Icon'

export default {
  components: {
    ProfileImage,
    Icon,
  },
  props: {
    size: {
      type: [Number, String],
      default: '',
    },
    userStatus: {
      type: Array,
      default: () => []
    },
    hideUserStatus: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      uploading: false,
      icons: {mdiCamera},
    }
  },
  methods: {
    ...mapActions(['updateUserProfile']),
    async changeImage(event) {
      const files = event.target.files

      if (files.length === 0) {
        return
      }

      this.uploading = true

      try {
        const uploadedImageBase64 = await this.convertFileToBase64(files[0])
        await this.updateUserProfile({
          image: uploadedImageBase64
        })

        this.uploading = false
      } catch (error) {
        this.uploading = false
        console.log(error)
      }
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          return resolve(reader.result)
        }
        reader.onerror = reject
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
}

.wrapper {
  position: relative;
}

.input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.icon {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  transform: translate(-50%, calc(-50% - 4px));
  filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2));
}
</style>
